import { useState, useEffect, useContext } from "react"
import AuthContext from "contexte/AuthContext"
import { useTranslation } from "react-i18next"
import "./newClients.css"
import DashboardLayout from "components/layout/dashboard/DashboardLayout"
import FilterComponent from "components/Filters/FilterComponent/FilterComponent"
import PageLoader from "components/pageLoader/PageLoader"
import Tableau from "components/DataComponents/Tableau/Tableau"
import { fetchReportNewClients } from "services/fetchUserReports"
import { formatDate, RELEASE_DATE } from "utils/date"


const NewClients = () => {

  const { user } = useContext(AuthContext);
  const { t } = useTranslation();

  const [newClients, setNewClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [selectedDate, setSelectedDate] = useState({
    date1: { startDate: new Date(RELEASE_DATE), endDate: new Date() },
    date2: { startDate: null, endDate: null },
  });
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);

  const fetchData = async () => {
    try {
      const endDate = selectedDate.date1?.endDate;
      const startDate = selectedDate.date1?.startDate;
      const data = await fetchReportNewClients({ user, startDate, endDate, limit, page });
      setNewClients(data);
      setLoading(false);

    } catch (e) {
      console.log(e);
      setError(true);
    }
  }

  useEffect(() => {
    fetchData()
  }, [page, limit, selectedDate.date1?.startDate, selectedDate?.date1?.endDate]
  );

  const transformDataToTbody = (data) => {

    return data.map(item => {

      return {
        data: [
          formatDate({ date: item.date, month: 'long' }),
          item.count,
          item.kyc,
          item.no_kyc,
          item.alpaca,
          item.no_alpaca
        ]
      };
    });
  }

  return (
    <DashboardLayout page={t("pages_name.report_users")}>
      <div>
        {
          !loading ? (
            <div>
              <div className="flexbox">
                <h3>Nouveaux Clients</h3>
                <FilterComponent
                  page={true}
                  limit={true}
                  date
                  fetchLimit={limit} setFetchLimit={setLimit}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                />
              </div>
              <div>
                <Tableau
                  thead={['Date', 'Nombre', 'KYC', 'No KYC', 'Alpaca', 'No Alpaca']}
                  tbody={transformDataToTbody(newClients)}
                  limit={limit}
                  page={page}
                  setPage={setPage}
                  pagination={true}
                />
              </div>
            </div>
          ) : (
            <div className='pageLoaderBox'>
              <PageLoader />
            </div>
          )
        }
      </div>
    </DashboardLayout>
  )
}

export default NewClients